var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts min-h-screen flex flex-col justify-between"},[_c('GeoSalesChart',{staticClass:"mb-8"}),_c('LineSalesChart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }